import { z } from "zod";
import { FormBuilderConsentInputType } from "@/constants/form-builder";
import type { TFunction } from "i18next";

export interface CreateConsentValidationProps {
  type: FormBuilderConsentInputType;
  required: boolean;
  t: TFunction;
}

export function createConsentValidation({
  type,
  required,
  t,
}: CreateConsentValidationProps) {
  switch (type) {
    case FormBuilderConsentInputType.Checkbox:
      return required
        ? z.boolean().refine((value) => value === true, {
            message: t("validation.error.code.REQUIRED"),
          })
        : z.boolean().optional();

    case FormBuilderConsentInputType.Dropdown:
      return required
        ? z.string().min(1, { message: t("validation.error.code.REQUIRED") })
        : z.string().optional();

    default:
      return z.any().optional();
  }
}
